import { useState } from "react";
import { RejectReason } from "../models/Claim";

type RejectReasonProps = {

    /**
     * Callback method that gets executed when dialog closes successful.
     * @param reason Reason for rejecting the current claim state.
     * @param othertxt Ohter Reason for rejecting the current claim state.
     * @returns void
     */
    onConfirm: (reason: RejectReason, othertxt: string) => void
}

const RejectReasonDialog = ({ onConfirm }: RejectReasonProps) => {

    const [reason, setReason]     = useState<number>(RejectReason.UNDEFINED);
    const [othertxt, setOtherTxt] = useState<string>();

    const [show, SetShow]   = useState<boolean>(false);
    const [error, setError] = useState<string>("");

    /** 
     * EventHandler that handles confirmation button click
     */
    function handleConfirm() : void {

        if (reason === RejectReason.Other.valueOf() && (othertxt === undefined || othertxt.trim() === ""))
        {
            setError("Please give another reason for the refusal.")
            return; // Abort code execution ...
        }

        SetShow(false); // Hidde dialog, no longer needed ...
        onConfirm(reason, othertxt ?? "");
    }

    return (

        <>
            <button className="btn btn-danger w-100" onClick={e => SetShow(true)}><i className="bi bi-x-circle me-2"></i>Decline</button>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>Please select a reason for refusal.</h5>
                            <button type="button" className="btn-close" onClick={e => SetShow(false)}></button>
                        </div>

                        <div className="modal-body">

                            <div className="row">

                                <div className="form-group col-12">
                                    <label htmlFor="modalReason" className="fw-bold">Reason</label>
                                    <select className="form-select" defaultValue={-1} name="modalReason" id="modalReason" onChange={e => setReason(Number(e.target.value))}>
                                        <option value={-1} disabled>Please select reason</option>
                                        <option value={0}>Check-in lists not signed</option>
                                        <option value={1}>Registration Fee not paid</option>
                                        <option value={2}>Ineligible (EU employee)</option>
                                        <option value={3}>Ineligible (Country not included in the project)</option>
                                        <option value={4}>Other</option>
                                    </select>
                                </div>

                                {(reason === RejectReason.Other) &&
                                    <div className="form-group col-12">
                                        <label htmlFor="modalOthertxt" className="fw-bold">Other Reason</label>
                                        <textarea value={othertxt} className="form-control" name="modalOthertxt" id="modalOthertxt" onChange={e => setOtherTxt(e.target.value)}></textarea>
                                        <span className="text-danger">{error}</span>
                                    </div>
                                }

                            </div>

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-danger"  type="button" onClick={e => SetShow(false)}>Close</button>
                            <button className="btn btn-success" type="button" onClick={handleConfirm}>Confirm</button>
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}
export default RejectReasonDialog;